// テーマの保存と反映。localStorage は境界なので例外の防御はここだけに置く。
// "system" は data-theme を外して prefers-color-scheme に委ねる、という 1 つの規則で表す。
export type ThemePref = "light" | "dark" | "system";

export const THEME_KEY = "anju:theme";

export function loadThemePref(storage: Pick<Storage, "getItem">): ThemePref {
  try {
    const raw = storage.getItem(THEME_KEY);
    return raw === "light" || raw === "dark" ? raw : "system";
  } catch {
    return "system";
  }
}

export function saveThemePref(storage: Pick<Storage, "setItem">, pref: ThemePref): void {
  try {
    storage.setItem(THEME_KEY, pref);
  } catch {
    // 保存できなくても、このセッションの表示は切り替わる
  }
}

/** 実際に描画される 2 値。"system" の解決だけが分岐で、以降のコードはこの 2 値だけを見る。 */
export function resolveTheme(pref: ThemePref): "light" | "dark" {
  if (pref !== "system") return pref;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyThemePref(pref: ThemePref): void {
  if (pref === "system") delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = pref;
}
